import OakLogo from "@/components/OakLogo";
import { Link } from "react-router-dom";
import Footer from "@/components/Footer";

export default function Refund() {
  return (
    <div className="min-h-screen" data-testid="refund-page">
      <nav className="max-w-5xl mx-auto px-6 py-5 flex items-center gap-3">
        <Link to="/" className="flex items-center gap-3"><OakLogo size={32} /><span className="font-display font-semibold">Oak AI Campus</span></Link>
      </nav>
      <main className="max-w-3xl mx-auto px-6 py-10 space-y-6 text-white/75 leading-relaxed">
        <div className="label-eyebrow">Legal</div>
        <h1 className="font-display text-4xl tracking-tight text-white">Refund Policy</h1>

        <Section title="Credit purchases">
          Credit purchases via Razorpay are non-refundable once redeemed (an exam has been unlocked). Unused credits are refundable within 7 days of purchase — email us your payment ID.
        </Section>
        <Section title="Failed transactions">
          If you were debited but no credits were granted, we will refund the exact amount to the original payment method within 5–7 business days.
        </Section>
        <Section title="Chargebacks">
          All chargebacks are investigated. Fraudulent chargebacks may result in account suspension.
        </Section>
        <Section title="Contact">
          Refund requests: <a className="text-[#8aa8ff]" href="mailto:info@oakaiapp.com">info@oakaiapp.com</a>.
        </Section>
      </main>
      <Footer />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="glass p-6">
      <h2 className="font-display text-xl tracking-tight text-white mb-2">{title}</h2>
      <p>{children}</p>
    </section>
  );
}
